var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 597,
    height: 434,
    viewBox: "0 0 597 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95443 445.401C50.7199 407.076 118.855 338.613 161.436 297.884C196.762 264.09 250.732 304.608 231.328 314.333C212.551 323.745 126.987 266.196 279.006 140.88C303.947 120.326 339.267 90.5331 363.448 69.0543C400.113 36.493 422.473 20.5741 435.745 16.5775C486.317 1.54657 375.367 155.119 364.355 141.816C356.367 132.17 480.648 12.9031 502.176 7.1217C523.087 1.51981 536.267 16.1532 513.539 53.3826C482.607 103.91 407.235 163.432 412.608 152.352C418.129 140.972 524.575 30.6303 538.375 23.3105C557.423 13.3577 567.375 22.5119 567.375 22.5119C593.404 46.4536 459.494 199.711 450.885 187.56C442.527 181.283 568.836 59.7637 587.381 77.5832C621.893 110.739 447.525 241.914 432.405 322.881C428.817 342.146 523.292 304.215 558.111 345.227C565.998 351.34 565.067 365.32 555.287 366.733C453.338 381.554 409.114 432.041 328.508 404.439C312.29 398.886 301.72 402.532 119.89 575.841",
    stroke: "#5DA7EB",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.442b1c2b665c2258ed8e709cf0ba42bf.svg";
export { ForwardRef as ReactComponent };